import React from 'react';
import './Header.css';

const Header = () => {
  return null; // Header is now integrated into Hero component
};

export default Header;
